<div
    class="fcp-chip-container fcp-chip-color-{{ color }} fcp-chip-{{ size }}"
    [ngClass]="{ 'fcp-chip-dismissible': dismissible }"
>
    <span>{{ item.text }}</span>
    <div *ngIf="dismissible" class="fcp-chip-icon" (click)="onRemove.emit(item.value)"></div>
</div>
